import Typography from "../../../../../../../../common/Typography";

const MembershipPurchased = ({ activity, currencyView }) => (
  <div className="membership-purchased-card">
    <div className="custom-row">
      <Typography size="heading-lg" weight="medium">
        Membership Purchased
      </Typography>
      <Typography size="heading-lg" weight="medium">
        {currencyView}
        {activity.bill_amount}
      </Typography>
    </div>
    <div className="custom-row">
      <Typography size="heading-sm">{activity.date_time}</Typography>
      <Typography weight="medium">
        {activity.membership_type === "reward_bundle" ? "Rewards Bundle" : "Wallet"}
      </Typography>
    </div>
  </div>
);

export default MembershipPurchased;
